import { render } from "./PageItem.vue?vue&type=template&id=539c8d3f&scoped=true"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"

import "./PageItem.vue?vue&type=style&index=0&id=539c8d3f&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539c8d3f"]])

export default __exports__